import { usePopupState } from "@/shared/hooks";

import { AddPanel } from "../controls/AddPanel";
import { SelectActiveLayout } from "../controls/SelectActiveLayout";
import { SelectLayout } from "../controls/SelectLayout/SelectLayout";
import {
  useActiveLayout,
  useEphemeralWorkspaceState,
} from "../WorkspaceCtx/hooks";

import { AddFilesButton } from "./AddFilesButton";
import styles from "./Header.module.css";
import { HeaderActionsMenu } from "./HeaderActionsMenu";
import { ShareWorkspaceButton } from "./ShareWorkspaceButton";
import { WorkspaceSettingsButton } from "./WorkspaceSettingsButton";

export function Header() {
  const { files } = useEphemeralWorkspaceState();
  const [activeLayout] = useActiveLayout();
  const layoutMenuPopup = usePopupState();

  return (
    <>
      <div className={styles.actions}>
        <SelectActiveLayout activeLayout={activeLayout} />
        <WorkspaceSettingsButton />
        <AddPanel />
        <AddFilesButton />
        <ShareWorkspaceButton />
        <HeaderActionsMenu
          className={styles.mobileVisible}
          fileRecord={files.length === 1 ? files[0] : undefined}
        />
      </div>
      <SelectLayout
        anchorEl={layoutMenuPopup.anchor}
        isOpen={layoutMenuPopup.isOpen}
        onClose={layoutMenuPopup.close}
      />
    </>
  );
}
